<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="resolvedSize"
    :height="resolvedSize"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path d="M12 6L0 6" :stroke="strokeCode" stroke-width="1.5" stroke-linecap="round" />
    <path d="M6 12L6 0" :stroke="strokeCode" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>

<script lang="ts" setup>
  import { computed, onMounted } from 'vue'

  const props = defineProps({
    stroke: {
      type: String,
      default: undefined,
    },
    size: {
      type: [String, Number],
      default: 12, // 기본값 12px
    },
  })

  const style = getComputedStyle(document.body)

  const strokeCode = style.getPropertyValue(props.stroke ?? '--Gray-800')

  const resolvedSize = computed(() =>
    typeof props.size === 'number' ? `${props.size}px` : props.size,
  )

  onMounted(() => {})
</script>

<style scoped lang="scss"></style>
